import { FC } from "react";
import QualityMonitor from "../../public/icons/QualityMonitor.svg";
import { IconProps, useAddMissingAntIconClass } from "../hooks/use-add-missing-ant-icon-class";

export const QualityMonitorIcon: FC<IconProps> = (iconProps) =>
  <span role="img" {...useAddMissingAntIconClass(iconProps)}><QualityMonitor/></span>;
